module.exports = __webpack_public_path__ + "img/binding_width.f28e2334.png";